<template>
  <div v-if="value" class="upgrade-modal-mask">
    <div class="upgrade-modal">
      <div class="upgrade-title">平台升级迁移通知</div>
      <div class="upgrade-content">
        <p>尊敬的合作伙伴：</p>
        <p>
          为帮助您高效对接美团接口能力，“美团餐饮直连平台”的开发者后台及文档将全面升级至“美团技术服务合作中心”。<br>
          <span class="warning">本次迁移不涉及直连平台厂商的接口改造，仅包括开发者控制台与文档查阅地址的变更。</span>
        </p>
        <p>
          迁移后，您可以在“美团技术服务合作中心”对接除餐饮直连平台以外的其他业务接口，如到餐排队、到餐预订、团购配送、服务零售等。<br>
          同时，“美团餐饮直连平台”将于2026年2月底下线，请尽快前往“美团技术服务合作中心”，使用餐饮直连平台的原账密即可登录控制台，如有问题请联系您的业务经理。
        </p>
        <p>
          更多信息，可查看《<a href="https://developer.meituan.com/docs/biz/biz_dishconnect_ef43c495-c944-4d1b-ab5d-8a884500c17a" target="_blank" class="link">美团餐饮直连平台迁移指引</a>》
        </p>
      </div>
      <div class="upgrade-actions">
        <Button class="upgrade-know" type="primary" long @click="onConfirm">我已知晓</Button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UpgradeNoticeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onConfirm() {
      this.$emit('input', false);
      this.$emit('confirm');
    }
  }
};
</script>
<style scoped>
.upgrade-modal-mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upgrade-modal {
  background: #fff;
  width: 480px;
  border-radius: 14px;
  padding: 32px 24px 24px 24px;
}
.upgrade-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #333333;
}
.upgrade-content {
  font-size: 15px;
  color: #171A1D;
  line-height: 1.9;
}
.warning {
  color: #FC5C2B;
  font-weight: 600;
}
.link {
  color: #1272ff;
  text-decoration: underline;
}
.upgrade-actions {
  margin-top: 28px;
  text-align: right;
}

.upgrade-know {
  font-size: 15px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/UpgradeNoticeModal.vue